import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "submit"
  ]

  static values = {
    url: String,
    method: String
  }

  connect() {
    this.previewInterval = window.setInterval(() => this.submitPreview(), 3000)
  }

  disconnect() {
    window.clearInterval(this.previewInterval)
  }

  submitPreview() {
    const previousAction = this.element.getAttribute("action")
    const previousMethod = this.element.getAttribute("method")
    const methodInput = this.element.querySelector('input[name="_method"]')
    const previousMethodOverride = methodInput?.value

    try {
      this.element.setAttribute("action", this.urlValue)

      if (methodInput) {
        methodInput.value = this.methodValue
      } else {
        this.element.setAttribute("method", this.methodValue)
      }

      this.element.requestSubmit()
    } finally {
      this.restoreAttribute("action", previousAction)
      this.restoreAttribute("method", previousMethod)

      if (methodInput) methodInput.value = previousMethodOverride
    }
  }

  restoreAttribute(name, value) {
    if (value === null) {
      this.element.removeAttribute(name)
    } else {
      this.element.setAttribute(name, value)
    }
  }
}
